import React, {useState} from "react";
import Loading from "../common/Loading";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import UseHubSettings from "./hooks/UseHubSettings";
import PipeSettings from "./PipeSettings";
import DeviceSettingsDrawer from "../device-settings/DeviceSettingsDrawer";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
    root: {},
    grid: {
        padding: theme.spacing(2),
    }
}));

export default function HubSettings({hubId, width, onClose}) {
    const classes = useStyles();

    const {
        hubLoading,
        pipesLoading,
        hub,
        pipes,
        handleHubTitleChanged,
        handlePipeTitleChanged,
        handlePipeStatusChanged,
        handlePipePeriodChanged,
        handleHubApplyClick,
        handlePipeApplyClick
    } = UseHubSettings({hubId});

    const [deviceId, setDeviceId] = useState(false);

    if (hubLoading || pipesLoading || !hub) {
        return <Loading/>;
    }

    return (
        <div className={classes.root}>
            <Grid container
                  direction={"row"}
                  justify={"center"}
                  alignItems={"center"}
                  spacing={2}
                  className={classes.grid}
                  style={{width: width}}
            >
                <Grid item xs={12} container justify={"space-around"} alignItems={"center"}>
                    <Grid item xs={2}>
                        <IconButton aria-label="close" disableRipple onClick={onClose} size={"small"}>
                            <CloseIcon/>
                        </IconButton>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography align={"center"}>Hub Configuration</Typography>
                    </Grid>
                    <Grid item xs={2}/>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="hub-title"
                        label="Title"
                        fullWidth
                        value={hub.title}
                        error={!hub.title.length}
                        inputProps={{
                            style: {textAlign: "center"}
                        }}
                        onChange={(event) => handleHubTitleChanged(event.target.value)}
                        onBlur={() => {
                            if (hub.title.length) handleHubApplyClick().then();
                        }}
                    />
                </Grid>
                <Grid item xs={12}
                      container
                      direction={"row"}
                      justify={"center"}
                      alignItems={"center"}
                      spacing={2}>
                    {
                        pipes.map(pipe => (
                            <Grid key={`hub-edit-pipe-${pipe.id}`} item xs={12}>
                                <PipeSettings pipe={pipe}
                                              onTitleChanged={handlePipeTitleChanged}
                                              onStatusChanged={handlePipeStatusChanged}
                                              onPeriodChanged={handlePipePeriodChanged}
                                              onApplyClick={handlePipeApplyClick}
                                              onDeviceConfigurationClick={() => setDeviceId(pipe["device_id"])}
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
            <DeviceSettingsDrawer open={!!deviceId}
                                  width={width}
                                  deviceId={deviceId}
                                  onClose={() => setDeviceId(undefined)}
            />
        </div>
    );
}